import React from 'react';

import {
  CircularProgress,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  PopperProps,
  Typography,
} from '@mui/material';

import { EmployeeUserOption } from '~/hooks/apis/users/useGetEmployeeUsers';

interface Props {
  isOpen: boolean;
  anchorEl: PopperProps['anchorEl'];
  suggestions: Array<EmployeeUserOption>;
  highlightedIndex: number;
  isError: boolean;
  onSelect: (employee: EmployeeUserOption) => void;
}

const POPPER_Z_INDEX = 1500;

export default function ChatterMentionPopover({
  isOpen,
  anchorEl,
  suggestions,
  highlightedIndex,
  isError,
  onSelect,
}: Props) {
  return (
    <Popper open={isOpen} anchorEl={anchorEl} placement="bottom-start" sx={{ zIndex: POPPER_Z_INDEX }}>
      <Paper elevation={8} sx={{ minWidth: 280, maxWidth: 420 }}>
        {suggestions.length > 0 ? (
          <MenuList dense role="listbox" aria-label="Mention suggestions">
            {suggestions.map((employee, index) => (
              <MenuItem
                key={employee.id_account}
                role="option"
                selected={index === highlightedIndex}
                aria-selected={index === highlightedIndex}
                // Keep the input focused so the mention can be inserted at the caret.
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => onSelect(employee)}
              >
                <ListItemText primary={employee.full_name} secondary={employee.email} />
              </MenuItem>
            ))}
          </MenuList>
        ) : (
          <Typography variant="body2" color="text.secondary" p={1.5}>
            {isError ? 'People search is unavailable.' : <CircularProgress size={16} />}
          </Typography>
        )}
      </Paper>
    </Popper>
  );
}
